// extracted by mini-css-extract-plugin
module.exports = {"StudiesProgrammeForm":"style_StudiesProgrammeForm__3oCyN","wrapper":"style_wrapper__RGTR4","column":"style_column__3hJD6","wrapperColumn":"style_wrapperColumn__kWtTW"};